import React, { useState, useEffect } from "react";
import { LanguageService } from "../../services/languageService";
import {
  Btn1,
  Btn1_en,
  Btn2,
  Btn2_en,
  Btn3,
  Btn3_en,
  Btn4,
  Btn4_en,
  drawer,
  float_role,
  Top,
} from "../../asset/images";
import "./drawer.scss";

const Drawer = () => {
  const [imageSet, setImageSet] = useState({});
  const [links, setLinks] = useState({});
  const [visible, setVisible] = useState(false);
  
  // Hàm phát hiện thiết bị iOS
  const isIOS = () => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  };
  
  useEffect(() => {
    const lang = LanguageService.detectLanguage();
    setImageSet({
      btn1: lang === "vi" ? Btn1 : Btn1_en,
      btn2: lang === "vi" ? Btn2 : Btn2_en,
      btn3: lang === "vi" ? Btn3 : Btn3_en,
      btn4: lang === "vi" ? Btn4 : Btn4_en,
    });
    setLinks(LanguageService.getLinks());
  }, []);

  useEffect(() => {
    const mainElement = document.querySelector(".Main");
    if (!mainElement) return;
    const observer = new IntersectionObserver(
      ([entry]) => setVisible(entry.isIntersecting),
      { threshold: 0.1 }
    );
    observer.observe(mainElement);
    return () => observer.unobserve(mainElement);
  }, []);

  const handleScrollToTop = () =>
    window.scrollTo({ top: 0, behavior: "smooth" });

  const navButtons = [
    { href: links.code, img: imageSet.btn1, alt: "code" },
    { href: isIOS() ? links.ios : links.android, img: imageSet.btn2, alt: "download" },
    { href: links.group, img: imageSet.btn3, alt: "community" },
    { href: links.fanpage, img: imageSet.btn4, alt: "support" },
  ];

  return (
    visible && (
      <div className="drawer">
        <div className="bg_drawer">
          <img src={drawer} alt="drawer" />
        </div>
        <div className="img">
          <img src={float_role} alt="float_role" />
        </div>
        <div className="nav__button">
          <ul className="nav__button__bar">
            {navButtons.map((btn, index) => (
              <a
                key={index}
                className="btn ten__hover"
                href={btn.href}
                target="_blank"
                rel="noopener noreferrer"
              >
                <li>
                  <img src={btn.img} alt={btn.alt} />
                </li>
              </a>
            ))}
          </ul>
        </div>
        <div className="btn__top" onClick={handleScrollToTop}>
          <img src={Top} alt="top" />
        </div>
      </div>
    )
  );
};

export default Drawer;
